import React, { useCallback, useEffect, useState } from 'react';
const names = ['Cecilia H.', 'Martín G.', 'Laura P.', 'Diego R.', 'Ana M.', 'Carlos S.', 'Lucía F.', 'Pablo T.'];
const cities = ['CABA', 'La Plata', 'Quilmes', 'Lomas de Zamora', 'Morón', 'San Isidro', 'Avellaneda', 'Lanús'];
const products = ['Pack Completo Matemática', 'Pack Completo Matemática', 'Primaria Lista', 'Secundaria Lista'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
    product: string;
    time: string;
  } | null>(null);
  const [visible, setVisible] = useState(false);
  const show = useCallback(() => {
    setNotification({
      name: randomItem(names),
      city: randomItem(cities),
      product: randomItem(products),
      time: String(Math.floor(Math.random() * 15) + 2)
    });
    // Small delay to allow DOM to paint the element before animating in
    requestAnimationFrame(() => {
      setVisible(true);
    });
    setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        setNotification(null);
        setTimeout(show, Math.floor(Math.random() * 25000) + 25000);
      }, 300);
    }, 4000);
  }, []);
  useEffect(() => {
    const t = setTimeout(show, 15000);
    return () => clearTimeout(t);
  }, [show]);
  if (!notification) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none transition-all duration-300" style={{
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateY(0)' : 'translateY(20px)'
  }} data-id="element-245">
      <div className="flex items-start gap-3" data-id="element-246">
        <span className="text-brand-accent text-sm mt-0.5" data-id="element-247">✅</span>
        <div data-id="element-248">
          <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-249">
            Compra verificada
          </div>
          <div className="text-xs text-white leading-tight mb-0.5" data-id="element-250">
            <span className="font-bold" data-id="element-251">{notification.name}</span> de{' '}
            {notification.city}
          </div>
          <div className="text-[11px] text-white/70 leading-tight mb-1.5" data-id="element-252">
            compró{' '}
            <span className="font-bold text-white" data-id="element-253">{notification.product}</span>{' '}
            🧮
          </div>
          <div className="text-[10px] text-white/60 italic font-medium" data-id="element-254">
            hace {notification.time} minutos
          </div>
        </div>
      </div>
    </div>;
}